import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${props => props.theme.spacing.sp16};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  align-items: center;
  transition: all 0.2s ease-in-out;

  ${props =>
    !props.isConnected &&
    css`
      cursor: pointer;

      &:hover {
        background-color: ${props => props.theme.colors.background.secondary};
        scale: 1.02;
      }
    `}
`

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
  height: 44px;
`

export const Logo = styled.img`
  width: 44px;
  height: 44px;
  border-radius: ${props => props.theme.primitives.radius.radius1};
`
